// extracted by mini-css-extract-plugin
module.exports = {"input":"FormText_input__luzdc","smallRect":"FormText_smallRect__RpV_y","outlined":"FormText_outlined__ryFnV"};